import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import pdf from "../../Assets/Lata.pdf";
import { AiOutlineDownload } from "react-icons/ai";

function Resume() {
  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="Sr. MERN DEVELOPER"
              date="May 2022 - Present"
              content={[
                "Web Technologies: HTML, CSS, XML, JavaScript, TypeScript, jQuery, JSON, Bootstrap, React JS, Redux, Redux-saga, Express JS and Node.js, graphql.",
                "Debugging tools: Chrome Developer Tools",
                "Databases: MONGO DB, PostgreSQL, CouchBase, MySQL, SQL Server.",
                "Experience in Version Control tool GIT.",
                "Managing user profile.",
                "Social login with google, facebook and email.",
                "Uploading user profile images from local system or web-cam",
                "Rendering html template in the backend",
                "Knowledge of how to interact with RESTful APIs and formats (JSON, XML) and Experience building user interfaces for websites and/or web applications.",
                "Communicate with the client to understand the requirement of the website, gained experience in project planning.",
              ]}
            />
            <Resumecontent
              title="Junior Full Stack Developer"
              date="Jan 2017 - Apr 2022"
              content={[
                "Web Technologies: HTML, HTML5, CSS3, XML, JavaScript, AJAX, jQuery, WordPress, JSON, Bootstrap, React JS, Redux, Express JS and Node.js.",
                "Debugging tools: Chrome Developer Tools.",
                "Databases: MONGO DB, PostgreSQL, Oracle 10g, MySQL, SQL Server.",
                "Knowledge of how to interact with RESTful APIs and formats (JSON, XML) and Experience building user interfaces for websites and/or web applications.",
                "Experience with front-end development and back-end system integration.",
                "Experience with designing and developing responsive design websites and also understand CSS changes and their ramifications to ensure consistent style across platforms and browsers.",
                "Experience in Version Control tool GIT.",
                "Ability to work effectively as a team member as well as an individual.",
                "Communicate with the client to understand the requirement of the website, gained experience in project planning.",
              ]}
            />
            <Resumecontent
              title="Junior SQL Developer"
              company = "Emicon Advisory Services"
              date="Jul 2015 - Mar 2016"
              content={[
                "Developed SQL databases and created applications to interface with SQL databases.", 
                "Key responsibilities were designing tables, developing SQL queries, creating custom reports, and modify ERP user forms to enhance organizational productivity.",
                "Development of high quality database solutions. Develop procedures and scripts for data migration.",
                "Research required data and investigate exceptions.",
                "Familiar with server development and maintenance and good with troubleshooting and data migration tasks.",
                "Extensively familiar with data management principles and best practices in order to properly store, migrate, and structure data for multiple applications."]}
            />
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="BTech(ECE) [Shoolini University, Solan] "
              date="2011 - 2015"
              content={[`CGPA: 7.3`]}
            />
            <Resumecontent
              title="12TH BOARD [Govt. Girl's School, Nahan]"
              date="2011"
              content={["Precentage: 66.5%"]}
            />
            <Resumecontent
              title="10TH BOARD [Govt. School, Ludhiana(H.P.)] "
              date="2009"
              content={["Precentage: 70%"]}
            />

            <h3 className="resume-title">Other Info</h3>
            <Resumecontent
              title="Email"
              content={[ `LATASHARMA1110@GMAIL.COM`]}
            />
            <Resumecontent
              title="Current Location"
              content={[ `Chandigarh`]}
            />
            <Resumecontent
              title="Gender"
              content={[`Female`]}
            />
            <Resumecontent
              title="Marital Status"
              content={[ ` Single`]}
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
          <AiOutlineDownload />&nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
